import { LocalizedText } from "../i18n/LocalizedCopy";
import { useSourceLanguage } from "../i18n/LocalizedCopy";
import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";
import "./EternuaMissionTeaser.css";

export default function EternuaMissionTeaser() {
  useSourceLanguage();
  const { t } = useI18n();
  return (
    <section className="et-mission-teaser" aria-labelledby="home-mission-title">
      <div>
        <p className="et-mission-teaser__eyebrow">{<LocalizedText source={t("memberMission.eyebrow", "Ce qui nous rassemble")} />}</p>
        <h2 id="home-mission-title">{<LocalizedText source={t("memberMission.title", "Moins d’isolement. Plus de liens humains.")} />}</h2>
        <p>{<LocalizedText source={t("memberMission.lead", "Eternua rapproche les personnes autour de l’entraide, des rencontres et de projets communs, avec la confiance pour fil conducteur.")} />}</p>
      </div>
      <Link to="/mission-eternua">{<LocalizedText source={t("memberMission.discover", "Découvrir la mission d’Eternua")} />}{" "}<span aria-hidden="true">→</span></Link>
    </section>
  );
}
